// @ts-nocheck
// Missed incoming calls for this affiliate (from their leads/customers or on their
// extension), with a one-click call back through their PBX extension.
import React, {useEffect, useState} from 'react'
import moment from 'moment'
import 'moment/locale/he'
import {AFF, card} from './affiliateTheme'
import {getPbxConfig, getPbxMissed, markPbxMissedHandled, pbxDial, getPbxStatus, inAffiliateApp, getPbxSoftphone} from '../core/_requests'

const STATE = {dialing: 'מחייג… כשיענה, השלוחה שלך תצלצל', answered: 'ענה — הרם את הטלפון', connected: 'בשיחה', no_answer: 'לא ענה', busy: 'תפוס', failed: 'החיוג נכשל'}

const MissedCallsPanel = () => {
  moment.locale('he')
  const [cfg, setCfg] = useState<any>(null)
  const [missed, setMissed] = useState<any[] | null>(null)
  const [dialing, setDialing] = useState<any>(null) // {id, text}

  const [appExt, setAppExt] = useState('') // inside the Android app, call back through the app's phone
  useEffect(() => {
    getPbxConfig().then((r) => setCfg(r.data)).catch(() => setCfg({available: false}))
    if (inAffiliateApp()) getPbxSoftphone().then((r) => setAppExt(r.data?.ext || '')).catch(() => {})
  }, [])
  useEffect(() => {
    if (!cfg?.available || !cfg?.extension) return
    const load = () => getPbxMissed().then((r) => setMissed(r.data || [])).catch(() => {})
    load()
    const t = setInterval(load, 20000)
    return () => clearInterval(t)
  }, [cfg?.available, cfg?.extension])

  const done = async (id) => {
    setMissed((m) => (m || []).filter((x) => x.id !== id))
    try { await markPbxMissedHandled(id) } catch (_) {}
  }
  const callBack = async (m) => {
    setDialing({id: m.id, text: 'מתחבר…'})
    try {
      const ext = appExt || cfg.extension
      await pbxDial(m.row._id, m.phone, ext)
      // Follow the call for ~40s so the button shows what happened.
      for (let i = 0; i < 27; i++) {
        await new Promise((r) => setTimeout(r, 1500))
        const st = (await getPbxStatus(ext)).data
        if (st.state) setDialing({id: m.id, text: STATE[st.state] || st.state})
        if (st.state === 'connected') { setMissed((x) => (x || []).filter((y) => y.id !== m.id)); break }
        if (['no_answer', 'busy', 'failed'].includes(st.state)) break
      }
    } catch (e) {
      setDialing({id: m.id, text: e?.response?.data?.error || e?.message || 'החיוג נכשל'})
    }
    setTimeout(() => setDialing((d) => (d && d.id === m.id ? null : d)), 8000)
  }

  if (!cfg?.available) return null
  return (
    <div style={{...card, padding: 20, marginBottom: 20, border: missed?.length ? '2px solid #f0b4ae' : undefined}}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
        <div style={{fontWeight: 800, fontSize: 16, color: missed?.length ? '#c0392b' : AFF.ink}}>
          <i className='bi bi-telephone-x-fill me-2' />שיחות שלא נענו {missed?.length ? `(${missed.length})` : ''}
        </div>
        {cfg.extension && <span style={{color: AFF.muted, fontSize: 13}}>שלוחה {cfg.extension}</span>}
      </div>
      {!cfg.extension ? (
        <div style={{color: AFF.muted}}>בחר שלוחה בעמוד "סוכנים ולידים" כדי לראות שיחות שלא נענו ולחזור ללקוחות.</div>
      ) : missed === null ? (
        <span className='spinner-border spinner-border-sm' />
      ) : !missed.length ? (
        <div style={{color: AFF.success, fontWeight: 600}}><i className='bi bi-check-circle me-2' />אין שיחות שלא נענו 👍</div>
      ) : missed.map((m) => (
        <div key={m.id} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', padding: '10px 0', borderTop: `1px solid ${AFF.border}`}}>
          <div>
            <div style={{fontWeight: 700, color: AFF.ink}}>
              {m.name || (m.phone ? 'מספר לא מזוהה' : 'מספר חסוי')}
              {m.phone && <span dir='ltr' className='ms-2' style={{fontWeight: 500, color: AFF.accent}}>{m.phone}</span>}
            </div>
            <div style={{fontSize: 12, color: AFF.muted}}>
              {moment(m.at).format('DD/MM HH:mm')} · {moment(m.at).fromNow()}{m.row?.agency_name ? ` · ${m.row.agency_name}` : ''}
            </div>
            {dialing?.id === m.id && <div style={{fontSize: 13, color: AFF.accent, fontWeight: 600, marginTop: 2}}>{dialing.text}</div>}
          </div>
          <div style={{display: 'flex', gap: 6}}>
            {m.row && m.phone ? (
              <button className='btn btn-sm btn-primary' disabled={dialing?.id === m.id} onClick={() => callBack(m)}>
                <i className='bi bi-telephone-fill me-1' />חזור
              </button>
            ) : m.phone ? (
              <a className='btn btn-sm btn-light-primary' href={`tel:${m.phone}`}><i className='bi bi-telephone me-1' />{m.phone}</a>
            ) : null}
            <button className='btn btn-sm btn-light' onClick={() => done(m.id)}>✓ טופל</button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MissedCallsPanel
